// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 20 ? "brand-mark" : chunkId) + "." + {"20":"cc1f05eb","750":"c154631a"}[chunkId] + ".chunk.js";
};